import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SITE_BULK_SECTION_EVENT,
	SITE_FILTER_EVENT,
	SITE_FOCUS_EVENT,
	SITE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['home.sites']);

/**
 * Open the All Sites section.
 * @param {string} sectionId semantic section identifier
 * @return {Promise<void>} section acknowledgement
 */
export function openSiteSection(sectionId) {
	return openResourceSection(SITE_SECTION_EVENT, sectionId, SECTIONS);
}

/**
 * Apply a Site inventory query.
 * @param {string} query Site query
 * @return {Promise<void>} filter acknowledgement
 */
export function applySiteFilter(query) {
	if (typeof query !== 'string' || !query.trim()) {
		return Promise.reject(new Error('invalid_site_filter'));
	}
	return dispatchAcknowledgedEvent(SITE_FILTER_EVENT, {
		query: query.trim(),
		resource: 'site',
	});
}

/**
 * Focus a resolved Site row.
 * @param {string} entityId opaque Site identifier
 * @return {Promise<void>} focus acknowledgement
 */
export function focusSite(entityId) {
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_site_entity'));
	}
	return dispatchAcknowledgedEvent(SITE_FOCUS_EVENT, {
		entityId,
		resource: 'site',
	});
}

const BULK_SECTIONS = new Set(['maintenance.bulk_add_sites']);

/**
 * Open the bulk Sites screen on the Maintenance tab.
 *
 * Bulk work lives there rather than beside the inventory it acts on, and
 * the screen is chosen inside that page rather than being a route of its
 * own - the same arrangement the Switch bulk screens already use.
 *
 * @param {string} sectionId semantic section identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function openSiteBulkSection(sectionId) {
	return openResourceSection(
		SITE_BULK_SECTION_EVENT,
		sectionId,
		BULK_SECTIONS,
	);
}
